import { render } from "./HomepageBanner.vue?vue&type=template&id=655cfdd0"
import script from "./HomepageBanner.vue?vue&type=script&lang=js"
export * from "./HomepageBanner.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__